const texto = valor => String(valor ?? '').trim();
const fecha = valor => texto(valor).slice(0, 10);

// Solo datos que afectan a la reserva de Correos; excluye selecciones aún sin confirmar.
export function datosReservaCorreos(reserva) {
  if (!reserva) return null;

  return {
    id: texto(reserva.id),
    codigo: texto(reserva.correos_booking_number),
    peregrinos: Number(reserva.cant_peregrinos || 0),
    inicio: fecha(reserva.fecha_inicio),
    llegada: fecha(reserva.fecha_llegada),
    etapas: (reserva.etapas || []).map(etapa => ({
      id: texto(etapa.pivot?.id ?? etapa.id),
      fecha: fecha(etapa.pivot?.fecha),
      proveedorId: texto(etapa.pivot?.proveedor_id),
      proveedorNombre: etapa.pivot?.proveedor_id ? '' : texto(etapa.pivot?.proveedor_nombre),
    })).sort((a, b) => a.id.localeCompare(b.id)),
  };
}

export function cambiosReservaCorreos(anterior, actual) {
  if (!anterior?.codigo || !actual?.codigo || anterior.id !== actual.id || anterior.codigo !== actual.codigo) {
    return [];
  }

  const cambios = [];
  const fechasEtapas = datos => datos.etapas.map(etapa => [etapa.id, etapa.fecha]);
  const alojamientos = datos => datos.etapas.map(etapa => [etapa.id, etapa.proveedorId, etapa.proveedorNombre]);

  if (anterior.inicio !== actual.inicio || anterior.llegada !== actual.llegada ||
      JSON.stringify(fechasEtapas(anterior)) !== JSON.stringify(fechasEtapas(actual))) {
    cambios.push('las fechas del itinerario');
  }
  if (anterior.peregrinos !== actual.peregrinos) cambios.push('la cantidad de peregrinos');
  if (JSON.stringify(alojamientos(anterior)) !== JSON.stringify(alojamientos(actual))) {
    cambios.push('los alojamientos del itinerario');
  }
  return cambios;
}
